<template>
  <el-card class="fla__card">
    <el-form
      ref="form"
      label-position="top"
      :model="form"
      :rules="rules"
    >
      <el-row :gutter="20">
        <el-col :xs="24" :sm="24">
          <el-form-item
            label="Series Title"
            prop="series_title"
          >
            <el-input
              v-model="form.series_title"
              @input="input"
              placeholder="Series title"
              :disabled="!editable"
            />
          </el-form-item>
        </el-col>

        <el-col :xs="24" :sm="24">
          <el-form-item
            label="Series Description"
            prop="series_description"
          >
            <el-input
              v-model="form.series_description"
              @input="input"
              placeholder="Series description"
              :disabled="!editable"
            />
          </el-form-item>
        </el-col>

        <el-col :xs="24" :sm="12">
          <el-form-item
            label="Genres"
            prop="genres">
            <el-select
              :value="form.genres | unwrap"
              @change="updateSelectorData($event, form, 'genres')"
              multiple
              allow-create
              filterable
              default-first-option
              :placeholder="(editable) ? 'Choose the genres' : 'Not selected'"
              :disabled="!editable"
            >
              <el-option-group
                v-for="group in genres"
                :key="group.label"
                :label="group.label">
                <el-option
                  v-for="item in group.options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                  </el-option>
                </el-option-group>
              </el-select>
          </el-form-item>
        </el-col>

        <el-col :xs="24" :sm="12">
          <el-form-item
            label="Topics"
            prop="topics">
            <el-select
              :value="form.topics | unwrap"
              @change="updateSelectorData($event, form, 'topics')"
              multiple
              allow-create
              filterable
              default-first-option
              :placeholder="(editable) ? 'Add topics' : 'Not selected'"
              :disabled="!editable"
            >
              <el-option-group
                v-for="group in topics"
                :key="group.label"
                :label="group.label">
                <el-option
                  v-for="item in group.options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-option-group>
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :xs="24" :sm="12" style="display:block">
          <el-form-item
            label="Year"
            prop="year">
            <el-date-picker
              v-model="form.year"
              @input="$emit('input', form.year)"
              type="year"
              placeholder="Pick a year"
              :picker-options="{
                disabledDate(time) {
                  return time.getTime() > Date.now();
                },
              }"
            ></el-date-picker>
          </el-form-item>
        </el-col>

        <!-- Note: Use to push down the referral input -->
        <el-col/>

        <el-col v-if="showReferral" :xs="24" :sm="12">
          <el-form-item
            label="Referral"
            prop="referral"
          >
            <p class="instruction">
              Film festival or curator who recommended you to Viddsee
            </p>
            <el-input
              v-model="form.referral"
              auto-complete="off"
              @input="input"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </el-card>
</template>

<script>
import Vue from 'vue';
import formValidationMixin from '@/mixins/formValidationMixin';
import selectorDataMaker from '@/utils/selectorDataMaker';
// Element-ui
import DatePicker from 'element-ui/lib/date-picker';
// Data
import topicsData from '@/assets/data/viddsee/topics';
import genresData from '@/assets/data/viddsee/genres';

// Components
import CollaboratorTable from '@/components/Submission/steps/CollaboratorDetails/CollaboratorItem/CollaboratorTable';

Vue.use(DatePicker);

export default {
  mixins: [
    formValidationMixin,
  ],
  components: {
    CollaboratorTable,
  },
  props: {
    value: {},
    editable: {
      type: Boolean,
      default: true,
    },
    showReferral: {
      type: Boolean,
      default: true,
    },
    showEmail: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      form: {
        ...this.value,
      },
      rules: {
        genres: [
          { required: true, trigger: 'change' },
        ],
        topics: [
          { required: true, trigger: 'change' },
        ],
        series_title: [
          { required: true, trigger: 'change' },
        ],
        series_description: [
          { required: true, trigger: 'change' },
        ],
        year: [
          { required: true, trigger: 'change' },
        ],
      },
      genres: [{ options: selectorDataMaker.make(genresData) }],
      topics: [{ options: selectorDataMaker.make(topicsData) }],
    };
  },
  filters: {
    unwrap(value) {
      return value ? value.split(',') : [];
    },
  },
  methods: {
    input() {
      this.$emit('input', this.form);
    },
    updateSelectorData(value, filmObject, prop) {
      this.$set(filmObject, prop, value.join(','));
      this.$emit('passData', this.form);
    },
  },
};
</script>

<style lang="scss" scoped>
.el-select {
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/Licenses/Others/SeriesCommonFieldForm.vue